import React from 'react';

export default function SimpleSteamGenerator2Icon({
  width = 64,
  height = 128,
  startColor = '#4C4C4C',
  midColor = '#C0C0C0',
  endColor = '#4C4C4C'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 56.195 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Steam_Generator">
	<path fill="#C0C0C0" stroke="#4C4C4C" strokeWidth="2" d="M0.001,112.5V42.004l13.852-13.964V0h28.153v28.041l14.188,13.964V112.5   H0.001z" />
</g>
<g id="Group_Line">
	<path fill="none" stroke="#4C4C4C" strokeWidth="2" d="M0.001,42.117h56.193" />
</g>
<g id="Group_Coil">
	<path fill="none" stroke="#4C4C4C" strokeWidth="2" d="M56.195,79.617h-9.347L9.348,75l37.5-4.729l-37.5-4.729l37.5-4.617   l-37.5-4.73l37.5-4.73l-37.5-4.617h37.5l-37.5,4.617l37.5,4.73l-37.5,4.73l37.5,4.617l-37.5,4.729L46.848,75l-37.5,4.617   l37.5,4.729l-37.5,4.617l37.5,4.729l-37.5,4.73l37.5,4.617H0.001" />
</g>
    
      </g>
      <rect x="0" y="0" width="56.195" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
